/**
 * Cache-Control header values for HTTP requests
 * Used to control caching behavior of HTTP responses
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control
 */
enum CacheControl {
  /**
   * Force revalidation with server before using cached response
   * Browser must check with server if content has changed
   */
  NoCache = 'no-cache',

  /**
   * Don't cache the response at all
   * Browser and intermediary caches must not store the response
   */
  NoStore = 'no-store'
}

export default CacheControl;
